export default {
  title: 'Agent Requests',
  columns: {
    no: 'No',
    agentCode: 'Agency',
    flightDates: 'Flight Dates',
    // request: 'Request',
    requestType: 'Request Type',
    routes: 'Routes',
    trips: 'Trips',
    createdAt: 'Created at',
    source: 'Source',
  },
  requestType: {
    SEARCH: 'Search',
    PAYMENT: 'Payment',
    CREATE: 'Create',
  },
  filters: {
    startDate: 'Start date',
    endDate: 'End date',
    agencyCode: 'Agency',
    requestType: 'Request Type',
    searchText: 'Search',
    ph: {
      searchText: 'Input and press ↵ to search',
    },
  },
  connectingFlight: 'Connecting Flight',
  ADULT: 'Adult',
  CHILD: 'Child',
  INFANT: 'Infant',
  directFlight: 'Direct Flight',
  combine: 'Combine',
  splitSegment: 'Split Segment',
  price: 'Price',
  updateSuccess: 'Successfully updated {lastName} {firstName}',
  confirmDelete: 'CONFIRM DELETION',
  confirmDeleteBankAccount: 'Are you sure you want to delete this bank account?',
  confirm: 'Confirm',
  cancel: 'Cancel',
  cannotDeleteDefaultAccount: 'Cannot delete the default account!',
}
